export { GenerateColorPipe } from './generateColor.pipe';
